export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE'
export const ACTIVE_LOCALE_HEADER = 'x-active-locale'
